import React from 'react'
import Menu, { MenuProps } from 'components/menu'
import Select from 'components/select'
import { useDataContext } from 'components/spreadsheet/contexts/data/useDataContext'
import { getOriginalViewColumns } from 'components/spreadsheet/helpers/functions'

const PivotMenu: React.FC<MenuProps> = ({ id, menuState, setMenuState, width }) => {
  const { spreadsheetData, setSpreadsheetData } = useDataContext()

  const hiddenColumns = spreadsheetData.userConfiguration.hiddenColumns
  const columnOptions = getOriginalViewColumns(spreadsheetData)
    .filter((col) => !hiddenColumns.includes(col.publicId))
    .map((col) => ({
      value: col.publicId,
      label: col.name
    }))

  const currentPivotColumnId = spreadsheetData.viewDetails.transposeSettings?.pivotColumnId ?? null

  const handleSelect = (columnId: string) => {
    if (columnId && columnId !== currentPivotColumnId) {
      setSpreadsheetData({ type: 'SET_PIVOT_COLUMN', pivotColumnId: columnId })
    }
  }

  return (
    <Menu id={id} menuState={menuState} setMenuState={setMenuState} width={width}>
      <div className="p-4 flex flex-col gap-3">
        <span className="text-sm font-medium text-body">Pivot Column</span>
        <Select
          options={columnOptions}
          onOptionClick={handleSelect}
          optionsSelected={currentPivotColumnId ? [currentPivotColumnId] : []}
          placeholder="Select a column..."
        />
      </div>
    </Menu>
  )
}

export default PivotMenu
